/** Снять фокус перед закрытием модалки — иначе «след» улетает с анимацией */
export function dismissFocus(event) {
  if (event?.currentTarget && typeof event.currentTarget.blur === 'function') {
    event.currentTarget.blur();
  }
  const active = typeof document !== 'undefined' ? document.activeElement : null;
  if (active && typeof active.blur === 'function' && active !== document.body) {
    active.blur();
  }
}

/**
 * Раньше здесь был preventDefault на mousedown — из‑за него клик
 * «Закрыть» не доходил (Safari / тач / свайп-панели).
 */
export function preventFocusOnPointer() {}

let ghostGuardUntil = 0;
let ghostGuardBound = false;

function ghostGuardHandler(event) {
  if (performance.now() > ghostGuardUntil) {
    document.removeEventListener('click', ghostGuardHandler, true);
    document.removeEventListener('pointerup', ghostGuardHandler, true);
    document.removeEventListener('mouseup', ghostGuardHandler, true);
    ghostGuardBound = false;
    return;
  }
  event.preventDefault();
  event.stopPropagation();
  if (typeof event.stopImmediatePropagation === 'function') {
    event.stopImmediatePropagation();
  }
}

/**
 * Глотает click/pointerup после закрытия по pointerdown —
 * иначе жест «пробивает» в dock (настройки) под диалогом.
 */
export function suppressGhostClick(durationMs = 420) {
  if (typeof document === 'undefined') return;
  ghostGuardUntil = Math.max(ghostGuardUntil, performance.now() + durationMs);
  if (ghostGuardBound) return;
  ghostGuardBound = true;
  document.addEventListener('click', ghostGuardHandler, true);
  document.addEventListener('pointerup', ghostGuardHandler, true);
  document.addEventListener('mouseup', ghostGuardHandler, true);
}

/** Закрыть по нажатию, не дожидаясь click, который могут съесть жесты. */
export function activateClose(event, closeFn) {
  if (event?.pointerType === 'mouse' && event.button != null && event.button !== 0) {
    return;
  }
  if (event) {
    if (typeof event.preventDefault === 'function') event.preventDefault();
    if (typeof event.stopPropagation === 'function') event.stopPropagation();
    dismissFocus(event);
  }
  suppressGhostClick(420);
  closeFn(event);
}
